import CustomerSearchInput from "../common/CustomerSearch";

export default function PartyFilter({
  customers,
  selectedCustomer,
  setCustomer,
}) {
  return (
    <div className="filter-section mt-3">
      <div className="field">
        <label>Party Name</label>
        <CustomerSearchInput
          customers={customers}
          placeholder="-- Select Party --"
          value={selectedCustomer}
          onChange={(customer) => setCustomer(customer)}
          inputClass="kw-customer-select"
        />
      </div>
    </div>
  );
}
